import { createContext, useContext, useState } from 'react';

const SimuladoContext = createContext(null);

export function SimuladoProvider({ children }) {



  const [simulado, setSimuladoState] = useState({
    id: localStorage.getItem('selectedSimuladoID') || null,
    status: parseInt(localStorage.getItem('examStatus')) || 0,
  });


  const [enableFlags, setEnableFlags] = useState({
    rankingEnable: false,
    examsEnable: false,
    localProvaEnable: false,
    cartaoRespostaEnable: false,
    gabaritoEnable: false,
  });

  const [provas, setProvas] = useState([]);

  // chamada quando o usuário seleciona um simulado no histórico
  const selectSimulado = (id) => {
    localStorage.setItem('selectedSimuladoID', id);
    setSimuladoState(prev => ({ ...prev, id }));
  };


  // chamada depois que a API do dashboard responde -- local único que atualiza todo o estado do simulado
  const updateSimuladoData = (apiData) => {

    localStorage.setItem('examStatus', apiData.exam_status);
    localStorage.setItem('rankingEnable', apiData.ranking_enable);
    localStorage.setItem('examsEnable', apiData.exams_enable);
    
    
    setSimuladoState(prev => ({ ...prev, status: apiData.exam_status }));


    setEnableFlags({
      rankingEnable: apiData.ranking_enable,
      examsEnable: apiData.exams_enable,
      localProvaEnable: apiData.exam_location_enable,
      cartaoRespostaEnable: apiData.answer_card_enable,
      gabaritoEnable: apiData.gabarito_enable,
    });

    setProvas(apiData.provas ?? []);




  };




  return (
    <SimuladoContext.Provider value={{ simulado, enableFlags, provas, selectSimulado, updateSimuladoData }}>
      {children}
    </SimuladoContext.Provider>
  );



}

export function useSimulado() {
  return useContext(SimuladoContext);
}
